import { useCallback } from 'react';

import useWebsocketExport from 'hooks/useWebsocketExport';
import { createReviewAttachmentsExport } from 'services/api/reviews';

export function useDownloadAttachments(reviewId: string) {
  const { exporting, initiateExport } = useWebsocketExport(
    (attachmentIds?: string[]) => createReviewAttachmentsExport(reviewId, attachmentIds),
    { download: true }
  );

  const downloadAttachments = useCallback(
    (attachmentIds?: string[]) => {
      if (exporting) return;
      initiateExport(attachmentIds);
    },
    [exporting, initiateExport]
  );

  return { downloadAttachments, isDownloading: exporting };
}
